import type { PostHog } from "posthog-js";

export const SHREDDED_AA_VARIANT_PROPERTY = "shredded_aa_variant";
const EXCLUDED_FLOW_IDS = new Set([
  "gccf-new-kitten",
  "fresh-new-user-influencer",
  "seven-day-trial",
  "fresh-feast-trial",
]);

type ShreddedAaVariant = "control" | "test";
type ShreddedAaSetOnceProperty = Record<
  typeof SHREDDED_AA_VARIANT_PROPERTY,
  ShreddedAaVariant
>;

interface GetShreddedAaSetOncePropertyArgs {
  posthog: Pick<PostHog, "getFeatureFlag">;
  flowId?: string;
}

const isShreddedAaVariant = (variant: unknown): variant is ShreddedAaVariant =>
  variant === "control" || variant === "test";

export const getShreddedAaSetOnceProperty = ({
  posthog,
  flowId,
}: GetShreddedAaSetOncePropertyArgs): ShreddedAaSetOnceProperty | undefined => {
  if (flowId && EXCLUDED_FLOW_IDS.has(flowId)) {
    return undefined;
  }

  const variant = posthog.getFeatureFlag("shredded-AA-Test");
  if (!isShreddedAaVariant(variant)) {
    return undefined;
  }

  return { [SHREDDED_AA_VARIANT_PROPERTY]: variant };
};
